import { UserDocumentType } from "../../../shared/enums/UserDocumentType";

export class UserDocumentChunk {
  id: string;
  title: string;
  chunkId?: number;
  content?: string;
  fileType: UserDocumentType;
  pageNumber?: number;
  boundingBox?: {
    xMin: number;
    yMin: number;
    xMax: number;
    yMax: number;
  };

  constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.chunkId = data.chunkId;
    this.content = data.content;
    this.fileType = data.fileType as UserDocumentType;
    this.pageNumber = data.pageNumber;
    this.boundingBox = data.boundingBox;
  }
}
